// src/api.js
const API_BASE = "https://konn3ct.com/api";

// ON LOAD: SHOW EVENTS FOR "la"
export const fetchAllEvents = async () => {
  const formData = new FormData();
  formData.append("search", "la");  // ← MAGIC "la" SEARCH

  try {
    const res = await fetch(`${API_BASE}/pre-registration-search`, {
      
      method: "POST",
      body: formData,
    });

    const json = await res.json();
    if (!res.ok || !json.success) throw new Error(json.message || "Failed");

    return (json.data || []).map(formatEventFromAPI);
  } catch (err) {
    console.error("fetchAllEvents error:", err.message);
    return [];
  }
};

// LIVE SEARCH
export const searchEvents = async (search = "", location = "All Locations") => {
  const formData = new FormData();
  formData.append("search", search.trim() || ""); // Always send search

  if (location && location !== "All Locations") {
    formData.append("location", location);
  }

  try {
    const res = await fetch(`${API_BASE}/pre-registration-search`, {
      method: "POST",
      body: formData,
    });

    const json = await res.json();
    console.log("Status:", res.status); // ← ADD THIS
    if (!res.ok || !json.success) throw new Error(json.message || "Failed");

    return (json.data || []).map(formatEventFromAPI);
  } catch (err) {
    console.error("searchEvents error:", err.message);
    return [];
  }
};

// FORMAT — REAL DATA
const formatEventFromAPI = (apiEvent) => {
  const dateStr = `${apiEvent.date} | ${apiEvent.time} (UTC+01:00)`;
  const { default: formatEventDates } = require("./KEventDate");
  const { dateString, fullDate } = formatEventDates(dateStr);

  // const logoUrl = apiEvent.logo
  //   ? `${API_BASE}/storage/${apiEvent.logo}`
  //   : "https://ui-avatars.com/api/?name=Event&background=10B981&color=fff";


const logoUrl = apiEvent.logo
    ? `https://konn3ct.com/prereg/${apiEvent.logo}`
    : "https://ui-avatars.com/api/?name=Event&background=10B981&color=fff";

  return {
    // ref: apiEvent.reference,
     ref: apiEvent.ref ?? apiEvent.reference,
    title: apiEvent.title,
    organizer: apiEvent.host_name,
    // location: apiEvent.timezone.split(" (")[0],
    location: "Konn3ct Room",
    date: dateStr,
    dateString,
    fullDate,
    description: apiEvent.about || "No description available.",
    image: logoUrl,
    logo: logoUrl,
    tag: "Hybrid",
    // tag: apiEvent.public === 1 ? "Hybrid" : "Private",
    free: apiEvent.free,           // 0 = paid, 1 = free
    amount: apiEvent.amount || "0", // for paid events
    currency: apiEvent.currency || "NGN",
    
  };
};

// SINGLE EVENT
export const fetchEventByRef = async (ref) => {
  try {
    const res = await fetch(`${API_BASE}/pre-registration/${ref}`);
    if (!res.ok) return null;
    const json = await res.json();
    const apiEvent = json.data?.preg?.[0] || json.data?.[0];
    return apiEvent ? formatEventFromAPI(apiEvent) : null;
  } catch {
    return null;
  }
};


// // src/api.js previous
// const API_BASE = "https://dev.konn3ct.ng/api";

// export const fetchAllEvents = async () => {
//   const formData = new FormData();
//   formData.append("search", "");           // ← Required
//   formData.append("location", "Africa/Lagos"); // ← Default to Lagos

//   try {
//     const res = await fetch(`${API_BASE}/pre-registration-search`, {
//       method: "POST",
//       body: formData,
//     });

//     const json = await res.json();
//     if (!res.ok || !json.success) throw new Error(json.message || "Failed");

//     return (json.data || []).map(formatEventFromAPI);
//   } catch (err) {
//     console.error("fetchAllEvents error:", err.message);
//     return [];
//   }
// };

// // SEARCH (keeps working as before)
// export const searchEvents = async (search = "", location = "All Locations") => {
//   const formData = new FormData();
//   formData.append("search", search.trim() || ""); // always send search

//   if (location && location !== "All Locations") {
//     formData.append("location", location);
//   }

//   try {
//     const res = await fetch(`${API_BASE}/pre-registration-search`, {
//       method: "POST",
//       body: formData,
//     });

//     const json = await res.json();
//     if (!res.ok || !json.success) throw new Error(json.message || "Failed");

//     return (json.data || []).map(formatEventFromAPI);
//   } catch (err) {
//     console.error("searchEvents error:", err.message);
//     return [];
//   }
// };

// // // FETCH ALL EVENTS — NO search field
// // export const fetchAllEvents = async () => {
// //   return await makeSearchRequest(); // ← No search
// // };

// // // SEARCH — Only send search if non-empty
// // export const searchEvents = async (search = "", location = "All Locations") => {
// //   const trimmed = search.trim();
// //   return await makeSearchRequest(trimmed || null, location);
// // };

// // FORM-DATA REQUEST
// const makeSearchRequest = async (searchValue = null, location = null) => {
//   const formData = new FormData();

//   // Only append if value exists
//   if (searchValue) formData.append("search", searchValue);
//   if (location && location !== "All Locations") formData.append("location", location);

//   try {
//     console.log("Sending:", 
//       searchValue ? `search=${searchValue}` : "",
//       location && location !== "All Locations" ? `location=${location}` : "",
//       "→ form-data"
//     );

//     const res = await fetch(`${API_BASE}/pre-registration-search`, {
//       method: "POST",
//       body: formData
//     });

//     const json = await res.json();
//     console.log("Response:", json);

//     if (!res.ok || !json.success) throw new Error(json.message || "Failed");

//     return (json.data || []).map(formatEventFromAPI);
//   } catch (err) {
//     console.error("API Error:", err.message);
//     return [];
//   }
// };

// // FORMAT — 100% MATCH
// const formatEventFromAPI = (apiEvent) => {
//   const dateStr = `${apiEvent.date} | ${apiEvent.time} (UTC+01:00)`;
//   const { default: formatEventDates } = require("../Data/KEventDate");
//   const { dateString, fullDate } = formatEventDates(dateStr);

//   // const logoUrl = apiEvent.logo
//   //   ? `${API_BASE}/storage/${apiEvent.logo}`
//   //   : "https://ui-avatars.com/api/?name=Event&background=10B981&color=fff";

//   return {
//     ref: apiEvent.reference,
//     title: apiEvent.title,
//     organizer: apiEvent.host_name,
//     // location: apiEvent.timezone.split(" (")[0], // ← Africa/Lagos
//     location: "Konn3ct Room",

//     dateString,
//     fullDate,
//     description: apiEvent.about || "No description available.",
//  image: "https://dev.konn3ct.ng/prereg/" + apiEvent.logo,
//     banner: apiEvent.logo || null,
   

//     tag: apiEvent.public === 1 ? "Hybrid" : "Private",
//   };
// };

// export const fetchEventByRef = async (ref) => {
//   try {
//     const res = await fetch(`${API_BASE}/pre-registration/${ref}`);
//     if (!res.ok) return null;
//     const json = await res.json();
//     const apiEvent = json.data?.preg?.[0];
//     return apiEvent ? formatEventFromAPI(apiEvent) : null;
//   } catch {
//     return null;
//   }
// };



// // src/api.js worked well
// const API_BASE = "https://dev.konn3ct.ng/api"; 

// // FETCH ALL EVENTS — NO search field
// export const fetchAllEvents = async () => {
//   return await makeSearchRequest(); // ← No search
// };

// // SEARCH — Only send search if non-empty
// export const searchEvents = async (search = "", location = "All Locations") => {
//   const trimmed = search.trim();
//   return await makeSearchRequest(trimmed || null); // ← null = omit
// };

// // FORM-DATA REQUEST
// const makeSearchRequest = async (searchValue = null) => {
//   try {
//     const formData = new FormData();

//     // ONLY append search if it's non-empty
//     if (searchValue && searchValue !== "") {
//       formData.append("search", searchValue);
//     }

//     console.log("Sending form-data:", 
//       searchValue ? `search=${searchValue}` : "NO search field"
//     );

//     const res = await fetch(`${API_BASE}/pre-registration-search`, {
//       method: "POST",
//       body: formData // ← No Content-Type → browser sets multipart/form-data
//     });

//     const json = await res.json();
//     console.log("Response:", json);

//     if (!res.ok || !json.success) {
//       throw new Error(json.message || "API Error");
//     }

//     return (json.data || []).map(formatEventFromAPI);
//   } catch (err) {
//     console.error("API Error:", err.message);
//     return [];
//   }
// };

// // FORMAT — 100% MATCHES POSTMAN
// const formatEventFromAPI = (apiEvent) => {
//   const dateStr = `${apiEvent.date} | ${apiEvent.time} (UTC+01:00)`;
//   const { default: formatEventDates } = require("../Data/KEventDate");
//   const { dateString, fullDate } = formatEventDates(dateStr);

//   const logoUrl = apiEvent.logo
//     ? `${API_BASE}/storage/${apiEvent.logo}`
//     : "https://ui-avatars.com/api/?name=Event&background=10B981&color=fff";

//   return {
//     ref: apiEvent.reference,
//     title: apiEvent.title,
//     organizer: apiEvent.host_name,
//     location: apiEvent.timezone.split(" (")[0],
//     dateString,
//     fullDate,
//     image: logoUrl,
//     banner: logoUrl,
//     tag: "Hybrid"
//   };
// };

// export const fetchEventByRef = async (ref) => {
//   try {
//     const res = await fetch(`${API_BASE}/pre-registration/${ref}`);
//     if (!res.ok) return null;
//     const json = await res.json();
//     const apiEvent = json.data?.preg?.[0];
//     return apiEvent ? formatEventFromAPI(apiEvent) : null;
//   } catch {
//     return null;
//   }
// };

